$(document).ready(function() {
	showYears()

  $("#year").change(function() {
      var yr = $("#year").val()  
      showMake(yr)
  })
  
  $("#make").change(function() {
    var yr = $("#year").val()
    var make = $("#make").val()
  	showModel(yr, make)
  })
  
  $("#select_search_btn").click(function() {
        deleteCookie('find-color');
    
  		var yr 			= $("#year").val()
    	var make_id 	= $("#make").val()
        var make		= $("#make option:selected").text()
        var model_id 	= $("#model").val()
        var model		= $("#model option:selected").text()
        
        setCookie("year", yr)
        setCookie("makeID", make_id)
        setCookie("modelID", model_id)
        setCookie("makeName", make)
        setCookie("modelName", model)        
        
        window.location.href = "/pages/search-colors";
  })
  
  $("#enter_search_color").click(function() { 
    	deleteCookie('year');
        deleteCookie('makeID');
        deleteCookie('modelID');
        deleteCookie('makeName');
        deleteCookie('modelName');
    
    	setCookie("find-color", $("input[name=search]").val())               
  		window.location.href = "/pages/search-colors";
  })  
  
  $("input[name=search]").keypress(function(e) {
    if(e.which == 13) {
      console.log('nothing happens')
//       alert('enter')
//       setCookie("find-color", $("input[name=search]").val())               
// //   	  window.location.href = "/pages/search-colors";
    }
  });
})


function showYears() {  
  $.ajax({
    type: 'GET',
    url : 'https://api.drcolorchip.com.hk/new/index.php/years',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },    
    dataType: 'json',    
    success: function(data) {      	
    	$.each(data, function (i, item) {
          $('#year').append($('<option>', { 
              value: item.year,
              text : item.year 
          }));
      	});
    },
    error: function(data) {
      console.log(JSON.stringify(data))      
    }
  })
}

function showMake(yr) {    
  $.ajax({
    type: 'GET',
    url: 'https://api.drcolorchip.com.hk/new/index.php/make/' + yr,
    headers: {
    	'Content-Type': 'application/x-www-form-urlencoded'
    },
    dataType: 'json',
    success: function(data) {
      	$('#make').empty()
        $('#make').append($('<option>', {
          value: 0,
          text: "選擇品牌"
        }))
        
    	$.each(data, function (i, item) {
          $('#make').append($('<option>', { 
              value: item.id,
              text : item.make_name 
          }));
      	});
    },
    error: function(data) {
    	console.log(JSON.stringify(data))
    }
  })
}

function showModel(yr, make) {
  $.ajax({
    type: 'GET',
    url: 'https://api.drcolorchip.com.hk/new/index.php/model/' + yr + '/' + make,
    headers: {
    	'Content-Type': 'application/x-www-form-urlencoded'
    },
    dataType: 'json',
    success: function(data) {
      	$('#model').empty()
        $('#model').append($('<option>', {
          value: 0,
          text: " 選擇車型"
        }))
        
    	$.each(data, function (i, item) {
          $('#model').append($('<option>', { 
              value: item.id,
              text : item.model_name 
          }));
      	});
    }, 
    error: function(data) {
    	console.log(JSON.stringify(data))
    }
  })
}

function setCookie(cname, cvalue) {
    document.cookie = cname + "=" + cvalue + ";" + /*expires +*/ ";path=/";
} 
function deleteCookie(name) {
    document.cookie = name+'="";-1; path=/';
}

